import { create } from "zustand";
export const useProductsStore = create((set) => ({
  products: null,
  product: null,
  setProducts: (products) => set({ products }),
  setProduct: (product) => set({ product }),
}));
